import { render, staticRenderFns } from "./ReturnOrderDetails.vue?vue&type=template&id=5a4afaa9&"
import script from "./ReturnOrderDetails.vue?vue&type=script&lang=js&"
export * from "./ReturnOrderDetails.vue?vue&type=script&lang=js&"
import style0 from "./ReturnOrderDetails.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src1768404630/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a4afaa9')) {
      api.createRecord('5a4afaa9', component.options)
    } else {
      api.reload('5a4afaa9', component.options)
    }
    module.hot.accept("./ReturnOrderDetails.vue?vue&type=template&id=5a4afaa9&", function () {
      api.rerender('5a4afaa9', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/containers/Customer/OrderWidget/Return/ReturnOrderDetails.vue"
export default component.exports